module.exports = __webpack_public_path__ + "img/banner.9b94c957.png";